import React from 'react';
require('./MedTypeIcon.scss');

export default ({ flagId = 7 }) => {
  const iconConfig = {
    0: {
      className: 'custom',
      description: 'Custom Medicine',
      iconText: 'C',
    },
    1: {
      className: 'otc',
      description: 'OTC Product',
      iconText: 'OTC',
    },
    2: {
      className: 'banned',
      description: 'Banned Medicine',
      iconText: 'B',
    },
    3: {
      className: 'undeliverable',
      description: 'Undeliverable Medicine',
      iconText: 'UD',
    },
    4: {
      className: 'schedule',
      description: 'Schedule X Medicine',
      iconText: 'sX',
    },
    5: {
      className: 'refrigerated',
      description: 'Refrigerated Medicine',
      iconText: 'Rx',
    },
    6: {
      className: 'rxReq',
      description: 'Prescription Required',
      iconText: 'Rx',
    },
    7: {
      className: 'noRxReq',
      description: 'No Prescription Required',
      iconText: 'Rx',
    },
    rxAvailable: {
      className: 'rxAvailable',
      description: 'Prescription already available',
      iconText: String.fromCharCode(10004), // Tick sign
    },
    loyalty: {
      className: 'loyalty',
      description: 'Plus Membership',
      iconText: 'Plus',
    }
  }[flagId] || {
    className: 'rxReq',
    description: 'Prescription Required',
    iconText: 'Rx',
  };

  return (<div className={'MedTypeIcon ' + iconConfig.className}>
    {iconConfig.iconText}<span className="tooltiptext">{iconConfig.description}</span>
  </div>);
}
